module.exports = __webpack_public_path__ + "./assets/fonts/OpenSans-Light.ttf?2d0bdc8df10dee036ca3bedf6f3647c6";